import { TENNAT_API_URL } from '@services/.env'
import { by, del } from '@services/custom.service'
import { BaseService } from '@services/base.service'
import i18n from '@src/i18n'

const t = i18n?.global?.t

export class SupportQueryService extends BaseService {
  static getSupportQueryTypes(commit, payload) {
    return by(`${TENNAT_API_URL}support_query_types/filters`, payload)
      .then((response) => {
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static getsupportQueries(commit, payload) {
    return by(`${TENNAT_API_URL}support_queries/filters`, payload)
      .then((response) => {
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static getSupportQueryMessages(commit, payload) {
    return by(`${TENNAT_API_URL}support_queries_conversations/filters`, payload)
      .then((response) => {
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static createAndUpdateSupportQueryType({ query, id }, commit) {
    return by(`${TENNAT_API_URL}support_query_types`, query, id)
      .then((response) => {
        commit(
          'toast/NEW',
          {
            type: 'success',
            message: id
              ? t('toast.SUPPORT_QUERY_TYPE_UPDATED_SUCCESSFULLY')
              : t('toast.SUPPORT_QUERY_TYPE_CREATED_SUCCESSFULLY'),
          },
          { root: true },
        )
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static createAndUpdateSupportQuery({ query, id }, commit) {
    return by(`${TENNAT_API_URL}support_queries`, query, id)
      .then((response) => {
        let message = id
          ? 'Support Query updated successfully'
          : 'Support Query created successfully'
        commit('toast/NEW', { message: message, type: 'success' }, { root: true })
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static sendConversationMessages(payload, commit) {
    return by(`${TENNAT_API_URL}support_queries_conversations`, payload)
      .then((response) => {
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static addParticipantInConversation(payload, commit) {
    return by(`${TENNAT_API_URL}support_queries/add_participant`, payload)
      .then((response) => {
        let message = 'Participants added successfully'
        commit('toast/NEW', { message: message, type: 'success' }, { root: true })
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static addWatcherInConversation(payload, commit) {
    return by(`${TENNAT_API_URL}support_queries/add_watcher`, payload)
      .then((response) => {
        let message = 'Watcher added successfully'
        commit('toast/NEW', { message: message, type: 'success' }, { root: true })
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static deleteSupportQueryType(id, commit) {
    return del(`${TENNAT_API_URL}support_query_types`, id)
      .then((response) => {
        commit(
          'toast/NEW',
          {
            type: 'success',
            message: t('toast.SUPPORT_QUERY_TYPE_DELETED_SUCCESSSFULLY'),
          },
          { root: true },
        )
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static deleteSupportQuery(data, commit) {
    return del(`${TENNAT_API_URL}support_queries`, data)
      .then((response) => {
        commit(
          'toast/NEW',
          { message: 'Support Query Type deleted successfully', type: 'success' },
          { root: true },
        )
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static closeSupportQuery(id, commit) {
    return by(`${TENNAT_API_URL}support_queries/close`, {}, id)
      .then((response) => {
        commit(
          'toast/NEW',
          { message: 'Support Query Type closed successfully', type: 'success' },
          { root: true },
        )
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }

  static reOpenSupportQuery(id, commit) {
    return by(`${TENNAT_API_URL}support_queries/reopen`, {}, id)
      .then((response) => {
        commit(
          'toast/NEW',
          { message: 'Support Query Type ReOpen successfully', type: 'success' },
          { root: true },
        )
        return [this.responseWrapper(response, response?.data), null]
      })
      .catch((error) => {
        const message = error.response.data ? error.response.data.error : error.response.statusText
        const responseError = this.errorWrapper(error, message)
        return [null, responseError]
      })
      .finally(() => {
        commit('layout/IS_LOADING', false, { root: true })
      })
  }
}
